export default "__VITE_ASSET__vqr24irR__"